import { render, staticRenderFns } from "./AdminHomeImage.vue?vue&type=template&id=20a059b6&scoped=true"
import script from "./AdminHomeImage.vue?vue&type=script&lang=ts"
export * from "./AdminHomeImage.vue?vue&type=script&lang=ts"
import style0 from "./AdminHomeImage.vue?vue&type=style&index=0&id=20a059b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a059b6",
  null
  
)

export default component.exports